import {useSelector} from "react-redux";
import _ from "lodash";
import moment from "moment";
import React from "react";

const SupportChatSessions = (props) => {
  const supportChatMessages = useSelector(state => state.supportChatMessages.filter(supportChatMessage => props.supportChatSessions.some(supportChatSession => supportChatSession.id === supportChatMessage.support_chat_session_id)))
  const translations = useSelector(state => (state.htmlContents || []).find(hc => hc.identifier == "support_chat.translations")?.json || {})

  const supportChatSessions = _.orderBy(props.supportChatSessions, (supportChatSession) => {
    const messages = supportChatMessages.filter(supportChatMessage => supportChatMessage.support_chat_session_id === supportChatSession.id)
    const last_change_at = moment((_.orderBy(messages, (supportChatMessage) => [moment(supportChatMessage.created_at).valueOf()], ['desc'])[0] || supportChatSession).created_at).valueOf()
    return [last_change_at]
  }, ['desc'])

  return <div className="row">
    {supportChatSessions.length === 0 ? <div className="col-12">
      <p>
        {translations?.currently_no_chats || "You currently have no chats here."}
      </p>
    </div> : null}
    {supportChatSessions.map((supportChatSession, index) => {
      const messages = supportChatMessages.filter(supportChatMessage => supportChatMessage.support_chat_session_id === supportChatSession.id)
      const lastMessage = _.orderBy(messages, (support_chat_message) => [moment(support_chat_message.created_at).valueOf()], ['desc'])[0]

      return <div
        key={supportChatSession.id}
        className={"col-12"}
        onClick={() => {
          props.setSelectedSupportChatSessionId ? props.setSelectedSupportChatSessionId(supportChatSession.id) : alert("Can't open support chat.")
        }}
      >
        {lastMessage ?
          <p className={"support-chat-session-row p-2 px-3 m-0" + (supportChatSession.complete ? " completed" : "")}>
            <strong>{lastMessage.written_by_tag_owner ? lastMessage.tag_owner_name : lastMessage.account_name}</strong>
            <br/>
            {lastMessage.body}
            <br/>
            {moment(lastMessage.created_at, 'YYYY-MM-DD[T]hh:mm:ssZ').fromNow()}
          </p> : <p className={"support-chat-session-row" + (supportChatSession.complete ? " completed" : "")}>
            No messages ...
          </p>}

        {supportChatSessions.length > index + 1 ? <hr className="m-0"/> : null}
      </div>
    })}
  </div>;
}

export default SupportChatSessions;